<template>
    <form>
        <div class="form-group">
            <label for="nome">Nome</label>
            <input type="text" class="form-control" id="nome" placeholder="Insira o seu nome">
        </div>
        <div class="form-group">
            <label for="api">API</label>
            <select class="form-control" id="api">
                <option>Opção 1</option>
                <option>Opção 2</option>
                <option>Opção 3</option>
                <option>Opção 4</option>
                <option>Opção 5</option>
            </select>
        </div>
        <div class="form-group">
            <label for="token">Token</label>
            <input type="text" class="form-control" id="token" placeholder="Insira o seu token">
        </div>

    </form>

</template>

<script>
export default {

}
</script>